import {
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  sendEmailVerification
} from 'firebase/auth'
import axios from 'axios'
import {auth} from '../../../../firebaseConfig'
import {API_URL} from '../../../../_metronic/global/data'
import { removeAuth } from './AuthHelpers'

export const LOGIN_URL = `${API_URL}users/login`
export const FORGOT_PASSWORD_URL = `${API_URL}users/forgot-password`
const JIT_MIGRATION_LOGIN_URL = `${API_URL}users/jit-migration-login`

const saveTokenToLocalStorage = (token: string, key: string = 'idToken') => {
  try {
    localStorage.setItem(key, token)
  } catch (error) {
    console.error('Error saving token to localStorage:', error)
  }
}

export const clearAuthStorage = () => {
  localStorage.removeItem('idToken')
}

// Server should return AuthModel
export async function login(email: string, password: string) {
  let cred: any
  try {
    cred = await signInWithEmailAndPassword(auth, email, password)
  } catch (error) {
    try {
      await axios.post(JIT_MIGRATION_LOGIN_URL, {email, password})
      cred = await signInWithEmailAndPassword(auth, email, password)
    } catch (jitError: any) {
      clearAuthStorage()
      await auth.signOut().catch(() => undefined)
      throw new Error(jitError?.response?.data?.message || 'Invalid Email or Password')
    }
  }

  if (!cred.user.emailVerified) {
    // Sign out the user since email is not verified
    await auth.signOut()
    clearAuthStorage()
    throw new Error("Please verify your email address before logging in. We’ve sent you a verification link.")
  }

  const idToken = cred._tokenResponse.idToken
  saveTokenToLocalStorage(idToken, 'idToken')
  
  return {
    data: {
      api_token: cred._tokenResponse.idToken,
      refreshToken: cred._tokenResponse.refreshToken,
    },
  }
}
// Sends the branded reset email. The backend answers 200 whether or not the address
// has an account, so a resolved promise says the request was accepted — not that a
// mail went out.
export function requestPassword(email: string) {
  return axios.post(FORGOT_PASSWORD_URL, {email})
}

// Function to resend verification email
export async function resendVerificationEmail(email: string, password: string) {
  try {
    const cred: any = await signInWithEmailAndPassword(auth, email, password)
    await sendEmailVerification(cred.user)
    await auth.signOut()
    clearAuthStorage()
    return { success: true, message: 'Verification email sent successfully!' }
  } catch (error: any) {
    if (auth.currentUser) {
      await sendEmailVerification(auth.currentUser)
      return { success: true, message: 'Verification email sent successfully!' }
    }
    throw new Error('Failed to send verification email. Please try again.')
  }
}

// Server should return AuthModel
export async function register(email: string, password: string) {
  const cred: any = await createUserWithEmailAndPassword(auth, email, password)
  // Send email verification using the imported function
  await sendEmailVerification(cred.user)
  return {
    data: {
      api_token: cred._tokenResponse.idToken,
      refreshToken: cred._tokenResponse.refreshToken,
    },
  }
}

// Removes current user and auth
export const logout = (dispatch:any) => {
  localStorage.removeItem('idToken')
  removeAuth(dispatch)
}
